import { render, staticRenderFns } from "./NonIndividualAffiliationsApplications.vue?vue&type=template&id=31d4cd1a&scoped=true&"
import script from "./NonIndividualAffiliationsApplications.vue?vue&type=script&lang=js&"
export * from "./NonIndividualAffiliationsApplications.vue?vue&type=script&lang=js&"
import style0 from "./NonIndividualAffiliationsApplications.vue?vue&type=style&index=0&id=31d4cd1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4cd1a",
  null
  
)

export default component.exports